import React from 'react';
import PropTypes from 'prop-types';
import ProcurementNavBar from '../../../../layouts/procurement/ProcurementNavBar';
import { PROCUREMENT, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import AccountReconciliationBody from './AccountReconciliationBody';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';

const ProcurementAccountReconciliation = ({ history }) => {
  useCheckTwoDepartments(`${PROCUREMENT}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <ProcurementNavBar currentPage="Account Reconciliation" position={firstName} />
        <AccountReconciliationBody />
      </main>
    </div>
  );
};

ProcurementAccountReconciliation.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default ProcurementAccountReconciliation;
